// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subtitle[data-v-591b43b4],.title[data-v-591b43b4]{text-align:center}.title[data-v-591b43b4]{font-family:EuclidFlex;font-size:var(--font-size-title-micro);font-weight:600;margin-bottom:16px}.subtitle[data-v-591b43b4]{font-size:var(--font-size);color:var(--color-dark-grey);margin-bottom:32px}", ""]);
// Exports
module.exports = exports;
